import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IRejectionReasonAmbulance, defaultValue } from 'app/shared/model/rejection-reason-ambulance.model';

export const ACTION_TYPES = {
  FETCH_REJECTION_REASON_AMBULANCE_LIST: 'rejectionReasonAmbulance/FETCH_REJECTION_REASON_AMBULANCE_LIST',
  FETCH_REJECTION_REASON_AMBULANCE: 'rejectionReasonAmbulance/FETCH_REJECTION_REASON_AMBULANCE',
  CREATE_REJECTION_REASON_AMBULANCE: 'rejectionReasonAmbulance/CREATE_REJECTION_REASON_AMBULANCE',
  UPDATE_REJECTION_REASON_AMBULANCE: 'rejectionReasonAmbulance/UPDATE_REJECTION_REASON_AMBULANCE',
  DELETE_REJECTION_REASON_AMBULANCE: 'rejectionReasonAmbulance/DELETE_REJECTION_REASON_AMBULANCE',
  RESET: 'rejectionReasonAmbulance/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IRejectionReasonAmbulance>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type RejectionReasonAmbulanceState = Readonly<typeof initialState>;

// Reducer

export default (state: RejectionReasonAmbulanceState = initialState, action): RejectionReasonAmbulanceState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_REJECTION_REASON_AMBULANCE):
    case REQUEST(ACTION_TYPES.UPDATE_REJECTION_REASON_AMBULANCE):
    case REQUEST(ACTION_TYPES.DELETE_REJECTION_REASON_AMBULANCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE):
    case FAILURE(ACTION_TYPES.CREATE_REJECTION_REASON_AMBULANCE):
    case FAILURE(ACTION_TYPES.UPDATE_REJECTION_REASON_AMBULANCE):
    case FAILURE(ACTION_TYPES.DELETE_REJECTION_REASON_AMBULANCE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_REJECTION_REASON_AMBULANCE):
    case SUCCESS(ACTION_TYPES.UPDATE_REJECTION_REASON_AMBULANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_REJECTION_REASON_AMBULANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/rejection-reason-ambulance';

// Actions

export const getEntities: ICrudGetAllAction<IRejectionReasonAmbulance> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE_LIST,
  payload: axios.get<IRejectionReasonAmbulance>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IRejectionReasonAmbulance> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_REJECTION_REASON_AMBULANCE,
    payload: axios.get<IRejectionReasonAmbulance>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IRejectionReasonAmbulance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_REJECTION_REASON_AMBULANCE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IRejectionReasonAmbulance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_REJECTION_REASON_AMBULANCE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IRejectionReasonAmbulance> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_REJECTION_REASON_AMBULANCE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
